export enum InvoiceType {
   "Factura",
   "Boleta",
   "GuiaDespacho",
   "FacturaCompra",
   "FacturaExportacion",
   "LiquidacionFactura",
   "NotaDebito",
   "NotaCredito",
}
